<template>
  <div>
    <my-head></my-head>
    <img src="../assets/Rectangle353.png" style="width: 100%" />
    <div class="keyindustries minH">
      <div class="crumbs">
        首页 >
        <span style="color: #1d2129">重点产业</span>
      </div>
      <div class="title flex-center">知识产权服务 助力产业升级</div>
      <div class="list flex-between-left flex-wrap">
        <div
          v-for="(item, index) in tabs"
          :key="index"
          :class="tab == item ? 'photocopy' : ''"
          @click="tab = item"
        >
          <div class="img flex-center">
            <img :src="item.img" />
          </div>
          <div class="biao_ti flex-center" v-text="item.title"></div>
          <div class="jian_jie" v-text="item.introduction"></div>
        </div>
      </div>
      <div class="biao_ti_xia flex-left-center">
        {{ tab.title }}
        <span>{{ tab.en }}</span>
      </div>
      <div class="jie_shao" v-html="tab.jieshao"></div>
      <img :src="tab.img2" class="img_two" />
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../components/MyHead.vue";
import MyFooter from "../components/MyFooter.vue";
export default {
  components: {
    MyHead,
    MyFooter,
  },
  data() {
    return {
      tabs: [
        {
          img: require("../assets/keyindustries/icon_1.png"),
          title: "生物医药",
          introduction: "生物技术产业与医药产业共同组成",
          en: "Biological drugs manufacture",
          jieshao: `生物医药产业由生物技术产业与医药产业共同组成，是综合应用生命科学与工程科学的原理和方法，从工程学角度在分子、细胞、组织、器官乃至整个人体系统多层次认识人体的结构、功能和其他生命现象，研究用于防病、治病、人体功能辅助及卫生保健的人工材料、制品、装置和系统技术的总称。
<br><br>
制药产业与生物医学工程产业是现代医药产业的两大支柱。生物医药产业由生物技术产业与医药产业共同组成。各国、各组织对生物技术产业的定义和圈定的范围很不统一，甚至不同人的观点也常常大相径庭。生物医学工程是综合应用生命科学与工程科学的原理和方法，从工程学角度在分子、细胞、组织、器官乃至整个人体系统多层次认识人体的结构、功能和其他生命现象，研究用于防病、治病、人体功能辅助及卫生保健的人工材料、制品、装置和系统技术的总称。制药产业与生物医学工程产业是现代医药产业的两大支柱。生物医药产业由生物技术产业与医药产业共同组成。各国、各组织对生物技术产业的定义和圈定的范围。生物医药产业由生物技术产业与医药产业共同组成。各国、各组织对生物技术产业的定义和圈定的范围很不统一，甚至不同人的观点也常常大相径庭。生物医学工程是综合应用生命科学与工程科学的原理和方法，从工程学角度在分子、细胞、组织、器官乃至整个人体系统多层次认识人体的结构、功能和其他生命现象，研究用于防病、治病、人体功能辅助及卫生保健的人工材料、制品、装置和系统技术的总称。`,
          img2: require("../assets/keyindustries/img_1.png"),
        },
        {
          img: require("../assets/keyindustries/icon_2.png"),
          title: "农业科技",
          introduction: "农业栽培更加精准，农产品流通更便捷",
          en: "Agricultural Technology",
          jieshao: `农业科技，主要就是用于农业生产方面的科学技术以及专门针对农村以及城市生活方面和一些简单的农产品加工技术。包括种植，养殖，化肥农药的用法，各种生产资料的鉴别，高效农业生产模式等几方面。
<br><br>
高科技的出现不仅改变了农业的生产方式，更是促进了农业的快速发展。它使得农业栽培更加精准，农产品流通更便捷，农业生产效率更高，对风险的预估能力更有效。在过去，农业科技领域可能是被低估的行业，它的发展对于企业和民众而言都有重大意义。未来，农业科技领域的潜力将越来越多地被注意到，因为新技术正在使农业更高产、更具可持续性，也将在全球的城市化过程中发挥更重要的作用。未来的农业发展将大大超出我们的想象，农业科技核心技术的发展必将带动现代农业的发展步伐。
<br><br>
中国农业发展非常需要科技的支持，科技创新是基础，要加快在农业科技方面实现关键技术突破，按照中国发展可持续农业、绿色生态农业的要求，育种技术、节水灌溉技术、土壤质量提升技术等都是农业产业发展的关键核心技术。`,
          img2: require("../assets/keyindustries/img_2.png"),
        },
        {
          img: require("../assets/keyindustries/icon_3.png"),
          title: "人工智能",
          introduction: "产业转型升级、国际竞争力提升的重要抓手",
          en: "Artificial Intelligence",
          jieshao: `人工智能（AI）是研究、开发用于模拟、延伸和扩展人的智能的理论、方法、技术及应用系统的一门新的技术科学，是计算机科学的一个分支，它企图了解人类智能的实质，并生产出一种新的能以人类智能相似的方式做出反应的智能机器，该领域的研究包括机器人、语言识别、图像识别、自然语言处理和专家系统等。随着移动互联网、大数据、超级计算、传感网、脑科学等新理论、新技术的快速发展，以及发展经济的强烈需求，人工智能产业得到了快速发展，并呈现出深度学习、跨界融合、人机协同、群智开放、自主操控等新特征。
<br><br>
在我国国家战略规划中，人工智能产业已超越技术概念，上升为国内产业转型升级、国际竞争力提升的重要抓手。在国发〔2017〕35号文《新一代人工智能发展规划》中，明确提出了面向2030年我国新一代人工智能发展的指导思想、战略目标、重点任务和保障措施，部署构筑了推动我国人工智能发展的体系基础，以加快建设创新型国家和世界科技强国。通过加快人工智能与经济、社会、国防的深度融合，提升新一代人工智能科技创新能力，构建开放协同的人工智能科技创新体系，全面支撑科技、经济、社会发展和国家安全。力争于2020年初步建成人工智能技术标准、服务体系和产业生态链，人工智能核心产业规模超过1500亿元。根据中国信息通信研究院发布的《2017年中国人工智能产业数据报告》显示，2017年我国人工智能市场规模达到216.9亿元，同比增长52.8%，预计2018年市场规模将达到339亿元。
<br><br>
为了更好的推动人工智能产业的发展，工信部印发了《促进新一代人工智能产业发展三年行动计划（2018-2020年）》，以信息技术与制造技术深度融合为主线，以新一代人工智能技术的产业化和集成应用为重点，推进人工智能和制造业深度融合，加快制造强国和网络强国建设。并按照“系统布局、重点突破、协同创新、开放有序”的原则，提出了四方面主要任务：一是重点培育和发展智能网联汽车、智能服务机器人、智能无人机、医疗影像辅助诊断系统、视频图像身份识别系统、智能语音交互系统、智能翻译系统、智能家居产品等智能化产品，推动智能产品在经济社会的集成应用；二是重点发展智能传感器、神经网络芯片、开源开放平台等关键环节，夯实人工智能产业发展的软硬件基础；三是深化发展航空航天，鼓励新一代人工智能技术在工业领域各环节的探索应用，提升智能制造关键技术装备创新能力，培育推广智能制造新模式；四是构建行业训练资源库、标准测试及知识产权服务平台、智能化网络基础设施、网络安全保障等产业公共支撑体系，完善人工智能发展环境。`,
          img2: require("../assets/keyindustries/img_3.png"),
        },
        {
          img: require("../assets/keyindustries/icon_4.png"),
          title: "航空航天",
          introduction: "知识、技术密集与高附加产值工业",
          en: "Aeronautical & Space Technologies",
          jieshao: `航空航天产业为飞行器及其所载各种设备和各种地面配套设备的制造业。航空航天产业通常包括生产企业和修理企业以及独立的或隶属于生产企业的研究部门、设计部门、销售部门、试验与试飞基地（中心）和管理部门。
<br><br>
航空航天工业是典型的知识与技术密集和附加产值很高的工业。在大气层中或在太空中飞行的飞行器都必须严格控制并尽量减轻自身的重量。这就会对飞行器设计、制造以至结构材料和电子元、器件提出苛刻的要求。因此，航空航天工业需要采用当代先进科学技术成果，它往往是反映一个国家科学技术和工业发展水平的部门。
<br><br>
航空航天工业是高度精密的综合性工业。航空航天产品的技术指标高，研制周期较长，零、部件种类繁多，有的产品关系到人员的生命安全，生产批量不大。在研制过程中还要作充分的研究和试验，需要有完备的试验设施和完善的技术保障措施。为了保证数以十万乃至百万计的零、组件总装后达到规定的可靠性和寿命指标，还要运用科学的管理方法。因此，航空航天工业是系统工程和现代管理工程实践最多的工业部门。
<br><br>
航空航天工业是军用与民用密切结合的工业。在相当长的时期内，军事需要一直是航空航天工业发展的重要推动力。在许多情况下，民用产品是在军用产品技术开拓的领域里发展的。喷气技术用于民用航空，火箭技术用于发射应用卫星，都属于这种情况。
<br><br>
航空工业与航天工业是紧密相关，常常是结合在一起的工业。航天工业是在航空工业的基础上发展起来的，而航天技术的发展又促进了航空工业的进步。航天飞机就是航空与航天技术的巧妙结合。大多数国家的航空与航天工业是结合为一体的工业。有时航空和航天形成两个部门，实际上只不过是在工业管理上的划分。`,
          img2: require("../assets/keyindustries/img_4.png"),
        },
        {
          img: require("../assets/keyindustries/icon_5.png"),
          title: "集成电路",
          introduction: "巨大市场需求，全球半导体产业关注焦点",
          en: "Integrated Circuit",
          jieshao: `集成电路（IC）在各行各业中发挥着非常重要的作用，是现代信息社会的基石，通常是指把一定数量的常用电子元件，如电阻、电容、晶体管等，以及这些元件之间的连线，通过半导体工艺集成在一起的具有特定功能的电路。按其功能、结构的不同，可以分为模拟集成电路、数字集成电路和数/模混合集成电路三大类。模拟集成电路又称线性电路，用来产生、放大和处理各种模拟信号，其输入信号和输出信号成比例关系，而数字集成电路用来产生、放大和处理各种数字信号。
<br><br>
近几年，中国集成电路产业取得了飞速发展。中国集成电路产业已经成为全球半导体产业关注的焦点，即使在全球半导体产业陷入有史以来程度最严重的低迷阶段时，中国集成电路市场仍保持了两位数的年增长率，凭借巨大的市场需求、较低的生产成本、丰富的人力资源，以及经济的稳定发展和宽松的政策环境等众多优势条件，以京津唐地区、长江三角洲地区和珠江三角洲地区为代表的产业基地迅速发展壮大，制造业、设计业和封装业等集成电路产业各环节逐步完善。2017年中国集成电路产业全年产量达到1564.58亿块，截至2018年11月份中国集成电路产业全年产量达到1577.1亿块，预计2018全年相较于2017年增长将超过10%。
<br><br>
目前，中国集成电路产业已经形成了IC设计、制造、封装测试三业及支撑配套业共同发展的较为完善的产业链格局，随着IC设计和芯片制造行业的迅猛发展，国内集成电路价值链格局继续改变，其总体趋势是设计业和芯片制造业所占比例将快速上升。`,
          img2: require("../assets/keyindustries/img_5.png"),
        },
        {
          img: require("../assets/keyindustries/icon_6.png"),
          title: "新一代信息技术",
          introduction: "七大战略性新兴产业之一行业规模超18万亿元",
          en: "Information Technology",
          jieshao: `新一代信息技术产业是指以电子设备、电子元器件、仪器仪表的研制与生产为核心的产业领域，通常由广播电视设备、通信导航设备、雷达设备、电子计算机、电子元器件、电子仪器仪表和其他电子专用设备等生产行业组成。根据我国工业和信息化部的分类方法，新一代信息技术产业分为电子信息制造业、软件与信息技术服务业。据统计2017年规模以上电子信息制造业收入超过13万亿元，软件和信息技术服务业收入突破5万亿元，行业整体规模超过18万亿元。随着新一代信息技术产业与其他领域产业融合、技术融合、市场融合的加速和深化，新一代信息技术产业已成为支撑我国制造强国、网络强国建设和我国经济社会创新发展的重要引擎。
<br><br>
近年来，新一代信息技术产业随着电子科学技术的发展和应用，得到了长足的发展。随着大规模集成电路和计算机的大量生产和使用，光纤通信、数字化通信、卫星通信等技术的兴起，使新一代信息技术产业成为一个迅速崛起的高技术产业。新一代信息技术产业的发展及其产品的广泛应用，对社会生活各领域都产生了深刻的影响。
<br><br>
新一代信息技术已经被确立为我国七大战略性新兴产业之一，将被重点推进。根据国发〔2010〕32号文《国务院关于加快培育和发展战略性新兴产业的决定》，新一代信息技术作为战略性新兴产业，将加快建设宽带、泛在、融合、安全的信息网络基础设施，推动新一代移动通信、下一代互联网核心设备和智能终端的研发及产业化，加快推进三网融合，促进物联网、云计算的研发和示范应用。着力发展集成电路、新型显示、高端软件、高端服务器等核心基础产业。提升软件服务、网络增值服务等信息服务能力，加快重要基础设施智能化改造。大力发展数字虚拟等技术，促进文化创意产业发展。新一代信息技术产业将聚焦于下一代通信网络、物联网、三网融合、新型平板显示、高性能集成电路和高端软件等范畴，涵盖技术多、应用范围广，与传统行业结合的空间大，在经济发展和产业结构调整中的带动作用将远远超出本行业的范畴。而物联网、三网融合等都并非单一产业，而是包含多个产业及核心技术在内的产业集群，这意味着其中某项核心技术一旦取得突破，都能够对于整个产业、甚至人民生活起到牵一发而动全身的效果。`,
          img2: require("../assets/keyindustries/img_6.png"),
        },
        {
          img: require("../assets/keyindustries/icon_7.png"),
          title: "新能源",
          introduction: "改善生态环境，培育新的经济增长点",
          en: "New Energy Resources",
          jieshao: `新能源产业是开发新能源的单位和企业所从事的工作的一系列过程。新能源产业主要是源于新能源的发现和应用。新能源指刚开始开发利用或正在积极研究、有待推广的能源，如太阳能、地热能、风能、海洋能、生物质能和核聚变能等。具有资源潜力大、环境污染低、可永续利用等特点。
<br><br>
大力发展新能源产业具有以下积极意义：减少污染排放、改善生态环境；培育新的经济增长点，拉动经济增长；缓解常规能源供给不足，保证能源可持续供应；服务新农村建设，提高群众生活质量等。
<br><br>
改革开放以来，在能源生产总量增长的同时，中国的能源结构也逐步完善和优化，煤炭在能源消费总量中所占比重逐步下降，水电、风电和太阳能、核能、生物质能等新能源和可再生能源所占比重不断提高，新能源技术创新取得了较大成效。我国新能源产业在发展过程中，仍存在以下主要问题：新能源产业结构不够完善；部分行业产能过剩；新能源核心技术亟待突破；发展过程中对政策的依赖程度高等等。`,
          img2: require("../assets/keyindustries/img_7.png"),
        },
        {
          img: require("../assets/keyindustries/icon_8.png"),
          title: "新材料",
          introduction: "二十一世纪最重要和最具发展潜力的领域",
          en: "New Material",
          jieshao: `包括新材料及其相关产品和技术装备。具体涵盖：新材料本身形成的产业；新材料技术及其装备制造业；传统材料技术提升的产业等。与传统材料相比，新材料产业具有技术高度密集，研究与开发投入高，产品的附加值高，生产与市场的国际性强，以及应用范围广，发展前景好等特点，其研发水平及产业化规模已成为衡量一个国家经济，社会发展，科技进步和国防实力的重要标志，世界各国特别是发达国家都十分重视新材料产业的发展。
<br><br>
新材料作为高新技术的基础和先导，应用范围极其广泛，它同信息技术，生物技术一起成为二十一世纪最重要和最具发展潜力的领域。同传统材料一样，新材料可以从结构组成，功能和应用领域等多种不同角度对其进行分类，不同的分类之间相互交叉和嵌套。
<br><br>
新材料主要由传统材料革新和新型材料的推出构成，随着高新技术的发展，新材料与传统材料产业结合日益紧密，产业结构呈现出横向扩散的特点。
新材料的分类：按照应用领域来分，一般把新材料归为以下几大类：
<br><br>
1. 信息材料
电子信息材料及产品支撑着现代通信，计算机，信息网络，微机械智能系统，工业自动化和家电等现代高技术产业。
<br><br>
2. 能源材料
全球范围内能源消耗在持续增长，80%的能源来自于化石燃料，从长远来看，需要没有污染和可持续发展的新型能源来代替所有化石燃料，未来的清洁能源包括氢能，太阳能，风能，核聚变能等。解决能源问题的关键是能源材料的突破，无论是提高燃烧效率以减少资源消耗，还是开发新能源及利用再生能源都与材料有着极为密切的关系。
<br><br>
3. 生物材料
生物材料是和生命系统结合，用以诊断，治疗或替换机体组织，器官或增进其功能的材料。它涉及材料，医学，物理，生物化学及现代高技术等诸多学科领域，已成为21世纪主要支柱产业之一。几乎所有类型的材料在健康治疗中都已得到应用，主要包括金属和合金，陶瓷，高分子材料，复合材料和生物质材料。高分子生物材料是生物医用材料中最活跃的领域；金属生物材料仍是临床应用最广泛的承力植入材料，医用钛及其合金，以及Ni-Ti形状记忆合金的研究与开发是一个热点；无机生物材料近年来越来越受到重视。
<br><br>
4. 汽车材料
汽车材料的需求呈现出以下特点：轻量化与环保是主要需求发展方向；各种材料在汽车上的应用比例正在发生变化，主要变化趋势是高强度钢和超高强度钢，铝合金，镁合金，塑料和复合材料的用量将有较大的增长，汽车车身结构材料将趋向多材料设计方向。同时汽车材料的回收利用也受到更多的重视，电动汽车，代用燃料汽车专用材料以及汽车功能材料的开发和应用工作不断加强。
<br><br>
5. 纳米材料与技术
纳米材料及技术将成为第5次推动社会经济各领域快速发展的主导技术，21世纪前20年将是纳米材料与技术发展的关键时期。纳电子代替微电子，纳加工代替微加工，纳米材料代替微米材料，纳米生物技术代替微米尺度的生物技术，这已是不以人的意志为转移的客观规律。
纳米材料与科技的研究开发大部分处于基础研究阶段，如纳米电子与器件，纳米生物等高风险领域，还没有形成大规模的产业。但纳米材料及技术在电子信息产业，生物医药产业，能源产业，环境保护等方面，对相关材料的制备和应用都将产生革命性的影响。
<br><br>
6. 超导材料与技术
超导材料与技术是21世纪具有战略意义的高新技术，广泛用于能源，医疗，交通，科学研究及国防军工等重大领域。超导材料的应用主要取决于材料本身性能及其制备技术的发展。
低温超导材料已经达到实用水平，高温超导材料产业化技术也取得重大突破，高温超导带材和移动通讯用高温超导滤波子系统将很快进商业化阶段。
<br><br>
7. 稀土材料
稀土材料是利用稀土元素优异的磁，光，电等特性开发出的一系列不可取代的，性能优越的新材料。稀土材料被广泛应用于冶金机械，石油化工，轻工农业，电子信息，能源环保，国防军工等多个领域，是当今世界各国改造传统产业，发展高新技术和国防尖端技术不可缺少的战略物资。类别主要包括稀土永磁材料、贮氢合金、稀土发光材料、稀土催化材料等。
<br><br>
8. 新型钢铁材料
新型钢铁材料发展的重点是高性钢铁材料。其方向为高性能，长寿命，在质量上已向组织细化和精确控制，提高钢材洁净度和高均匀度方面发展。
<br><br>
9. 新型有色金属合金材料
主要包括铝，镁，钛等轻金属合金以及粉末冶金材料，高纯金属材料等。
<br><br>
10. 新型建筑材料
新型建筑材料主要包括新型墙体材料，化学建材，新型保温隔热材料，建筑装饰装修材料等。国际上建材的趋势正向环保，节能，多功能化方向发展。
<br><br>
11. 新型化工材料
新型化工材料主要包括有机氟材料，有机硅材料，高性能纤维，纳米化工材料，无机功能材料等；纳米化工材料和特种化工涂料是近年来的研究热点。精细化，专用化，功能化成了化工材料工业的重要发展趋势。
<br><br>
12. 生态环境材料
主要包括：环境相容材料，如纯天然材料（木材，石材等），仿生物材料（人工骨，人工器脏等），绿色包装材料（绿色包装袋，包装容器），生态建材（无毒装饰材料等）；环境降解材料（生物降解塑料等）；环境工程材料，如环境修复材料，环境净化材料（分子筛，离子筛材料），环境替代材料（无磷洗衣粉助剂）等。
生态环境材料研究热点和发展方向包括再生聚合物（塑料）的设计，材料环境协调性评价的理论体系，降低材料环境负荷的新工艺，新技术和新方法等。`,
          img2: require("../assets/keyindustries/img_8.png"),
        },
      ],
      tab: {},
    };
  },
  mounted() {
    let type = parseInt(this.$route.query?.type);
    if (type) {
      this.tab = this.tabs[type];
    } else {
      this.tab = this.tabs[0];
    }
  },
};
</script>

<style lang="scss">
.keyindustries {
  width: 80%;
  margin: 0 auto;
  padding: 35px 0 150px;
  .img_two {
    width: 100%;
  }
  .jie_shao {
    font-size: 14px;
    font-weight: 400;
    color: #4e5969;
    line-height: 28px;
    margin-bottom: 32px;
  }
  .biao_ti_xia {
    margin-top: 56px;
    margin-bottom: 32px;
    font-size: 20px;
    font-weight: 500;
    color: #1d2129;
    line-height: 28px;
    span {
      margin-left: 12px;
      font-size: 18px;
      font-weight: 400;
      color: #c9cdd4;
      line-height: 26px;
    }
  }
  .list {
    & > div {
      width: 22%;
      transition: all 0.5s;
      cursor: pointer;
      padding: 24px 64px;
      margin-bottom: 24px;
      border-radius: 8px;
      .jian_jie {
        font-size: 14px;
        font-weight: 400;
        color: #86909c;
        line-height: 22px;
        text-align: center;
      }
      .biao_ti {
        font-size: 18px;
        font-weight: 500;
        color: #1d2129;
        line-height: 28px;
        margin-bottom: 8px;
      }
      .img {
        width: 100%;
        height: 50px;
        img {
          width: 33.33px;
        }
      }
      &:hover {
        transition: box-shadow 0.3s, border-color 0.3s;
        visibility: visible;
        box-shadow: 0px 0px 20px #ccc;
      }
    }
  }
  .title {
    font-size: 30px;
    font-weight: bold;
    color: #1d2129;
    line-height: 38px;
    margin-bottom: 64px;
  }
  .crumbs {
    font-size: 12px;
    color: #86909c;
    margin-bottom: 35px;
  }
}
</style>
